import styled from "styled-components";

export const ButtonStyle = styled.button`
 background-color: #fb8;
 padding: 12px 32px;
 margin: 0 auto;
 margin-top: 16px;
 font-size: 16px;
 border-radius: 5px;
 border: none;
 color: rgba(28, 28, 28, 0.9);
 cursor: pointer;

 :hover {
  background-color: rgba(255, 187, 136, 0.8);
 }
`;
